import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Importation des images de voitures
import CHR from "assets/CARS/CHR.png";
import MODELE3 from "assets/CARS/MODELE 3.png";
import MODELEY from "assets/CARS/MODELE Y.png";
import ENIRO from "assets/CARS/ENIRO.png";

const carImages = {
  CHR: CHR,
  "MODELE 3": MODELE3,
  MODELE3: MODELE3,
  "MODELE Y": MODELEY,
  MODELEY: MODELEY,
  "MODEL 3": MODELE3,
  "MODEL Y": MODELEY,
  MODEL3: MODELE3,
  MODELY: MODELEY,
  ENIRO: ENIRO,
  "E-NIRO": ENIRO,
};

function VehicleCard({ marque, immat, loading }) {
  // Obtenir l'image de la voiture selon la marque
  const carImage = carImages[marque?.toUpperCase()] || carImages.CHR;

  if (loading) {
    return (
      <Card>
        <MDBox p={2}>
          <MDBox mb={2}>
            <MDTypography variant="h6" fontWeight="medium" textTransform="uppercase">
              Véhicule
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              width: "100%",
              height: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
            }}
          >
            <CircularProgress />
          </MDBox>
          <MDBox mt={2} textAlign="center">
            <MDTypography variant="button" color="text">
              Chargement...
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    );
  }

  return (
    <Card>
      <MDBox p={2}>
        <MDBox mb={2}>
          <MDTypography variant="h6" fontWeight="medium" textTransform="uppercase">
            Véhicule
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            width: "100%",
            height: "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          <img
            src={carImage}
            alt={marque || "Véhicule"}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </MDBox>
        <MDBox mt={2} textAlign="center">
          <MDTypography variant="h5" fontWeight="bold">
            {immat || "Non disponible"}
          </MDTypography>
          {marque && (
            <MDTypography variant="button" color="text" fontWeight="regular">
              {marque}
            </MDTypography>
          )}
        </MDBox>
      </MDBox>
    </Card>
  );
}

VehicleCard.propTypes = {
  marque: PropTypes.string,
  immat: PropTypes.string,
  loading: PropTypes.bool,
};

VehicleCard.defaultProps = {
  marque: "",
  immat: "",
  loading: false,
};

export default VehicleCard;
